import { render, staticRenderFns } from "./common-future-workload.vue?vue&type=template&id=0baa04dc&"
import script from "./common-future-workload.vue?vue&type=script&lang=js&"
export * from "./common-future-workload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports